import { ColDef } from 'ag-grid-enterprise'

import { TagsCellEditor } from '@/ag-grid/columns/tags/cell-editor'
import { TagsCellRenderer } from '@/ag-grid/columns/tags/renderer'

export const tags: ColDef<{ tags: string | null }> = {
  field: 'tags',
  width: 300,
  editable: true,
  valueGetter: (params) => {
    const originalValue = params.data?.tags
    if (originalValue && typeof originalValue === 'string') {
      return originalValue.split(',')
    }
    return []
  },
  valueSetter: (params) => {
    if (
      params.newValue &&
      Array.isArray(params.newValue) &&
      params.newValue.every((v) => typeof v === 'string')
    ) {
      const newValue = params.newValue.join(',')
      params.data.tags = newValue
      return true
    }

    return false
  },
  cellRenderer: TagsCellRenderer,
  cellEditor: TagsCellEditor,
}
